<script setup>
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
// import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];

const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});
</script>
<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Sign In</h4>
                  <p class="mb-0">Enter your username and password to sign in</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="signIn">
                    <div class="mb-3">
                      <argon-input id="username" type="text" placeholder="Username" v-model="username" name="username"
                        size="lg" />
                    </div>
                    <div class="mb-3">
                      <argon-input id="password" type="password" placeholder="Password" v-model="password"
                        name="password" size="lg" />
                    </div>
                    <argon-switch id="rememberMe" name="remember-me" v-model="rememberMe">
                      Remember me
                    </argon-switch>

                    <div class="text-center">
                      <argon-button class="mt-4" variant="gradient" color="dark" fullWidth size="lg" type="submit">
                        Sign in
                      </argon-button>
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    Don't have an account?
                    <a href="javascript:;" class="text-success text-gradient font-weight-bold">Sign up</a>
                  </p>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="
                  background-image: url(&quot;https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg&quot;);
                  background-size: cover;
                ">
                <span class="mask bg-gradient-dark opacity-6"></span>
                <h4 class="mt-5 text-white font-weight-bolder position-relative">
                  "Attention is the new currency"
                </h4>
                <p class="text-white position-relative">
                  The more effortless the writing looks, the more effort the
                  writer actually put into the process.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
// import axios from 'axios';
import api from "../utils/api";

export default {
  data() {
    return {
      username: '',
      password: '',
      rememberMe: false
    };
  },
  methods: {
    async signIn() {
      const data = {
        username: this.username,
        password: this.password,
      };


      try {

        const response = await api.post("/auth/login", { ...data });
        if (response.data?.message == 'success') {
          localStorage.setItem('access_token', response.data?.data?.access_token);
          localStorage.setItem('user_id', response.data?.data?.user_id);
          localStorage.setItem('user_email', response.data?.data?.user_email);
          localStorage.setItem('username', this.username);
          localStorage.setItem('password', this.password);
          // Redirect to the dashboard after successful login
          this.$router.push('/dashboard');
        }
      } catch (error) {

        var err = error.response.data.message
        this.$swal({
          title: "Warining",
          text: err,
          icon: "warning"
        });

      }
      // console.log({ response })

      // axios.request(config)
      //   .then((response) => {
      //     if (response.data?.message == 'success') {
      //       localStorage.setItem('access_token', response.data?.data?.access_token);
      //       localStorage.setItem('user_id', response.data?.data?.user_id);
      //       localStorage.setItem('user_email', response.data?.data?.user_email);
      //       localStorage.setItem('username', this.username);
      //       localStorage.setItem('password', this.password);
      //       // Redirect to the dashboard after successful login
      //       this.$router.push('/dashboard');
      //     }

      //   })
      //   .catch((error) => {
      //     var err = error.response.data.message
      //     this.$swal({
      //       title: "Warining",
      //       text: err,
      //       icon: "warning"
      //     });
      //   });
    }
  },
  mounted() {
    console.log(process.env)
    if (localStorage.getItem('username')) {
      this.username = localStorage.getItem('username');
      this.password = localStorage.getItem('password');
      this.rememberMe = true;
    }
  }
};
</script>
